// @flow

import { connect } from "react-redux";

import { Tabs } from "@quantum/ui";

import { activeTab, setActiveTab } from "./state";

export const ConnectedTabs = connect(
  (state, { id }) => ({
    activeTab: activeTab(id, state),
  }),
  (dispatch, { id }) => ({
    onChange: tabId => dispatch(setActiveTab(id, tabId)),
  })
)(Tabs);
